module.exports = __webpack_public_path__ + "img/教育认证-上传材料.596eb5db.png";